<div class="view-auth-container">
  <table rs-table [dataSource]="userAndAdminAuthsValue" style="width:100%;" class="table search-table colored-table">
    @for (header of tableHeaders; track header) {
      @if (header === 'tin') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1">TIN</th>
          <td rs-cell *rsCellDef="let element" class="col-1">{{element.tin}}</td>
        </ng-container>
      }
      @if (header === 'agencyName') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1">Agency Name</th>
          <td rs-cell *rsCellDef="let element" class="col-1">{{element.agencyName}}</td>
        </ng-container>
      }
      @if (header === 'npn') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1">NPN</th>
          <td rs-cell *rsCellDef="let element" class="col-1">{{element.npn}}</td>
        </ng-container>
      }
      @if (header === 'agentName') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1">Agent Name</th>
          <td rs-cell *rsCellDef="let element" class="col-1">{{(element.agentFirstName || '') + ' '+
          (element.agentLastName || '')}}</td>
        </ng-container>
      }
      @if (header === 'groupCommissionStatementsInd') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1" style="text-align: center;">
            <div style="padding: 10px 25px;">Group Commission Statements</div>
          </th>
          <td rs-cell *rsCellDef="let element" class="col-1" style="text-align: center;">
            <rs-checkbox [checked]="element.targetUserAuthorizations[header]" disabled></rs-checkbox>
          </td>
        </ng-container>
      }
      @if (header === 'individualCommissionStatementsInd') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1" style="text-align: center;">
            <div style="padding: 10px 25px;">Individual Commission Statements</div>
          </th>
          <td rs-cell *rsCellDef="let element" class="col-1" style="text-align: center;">
            <rs-checkbox [checked]="element.targetUserAuthorizations[header]" disabled></rs-checkbox>
          </td>
        </ng-container>
      }
      @if (header === 'groupBookOfBusinessInd') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1" style="text-align: center;">
            <div style="padding: 10px 25px;">Group Book of Business</div>
          </th>
          <td rs-cell *rsCellDef="let element" class="col-1" style="text-align: center;">
            <rs-checkbox [checked]="element.targetUserAuthorizations[header]" disabled></rs-checkbox>
          </td>
        </ng-container>
      }
      @if (header === 'individualBookOfBusinessInd') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1" style="text-align: center;">
            <div style="padding: 10px 25px;">Individual Book of Business</div>
          </th>
          <td rs-cell *rsCellDef="let element" class="col-1" style="text-align: center;">
            <rs-checkbox [checked]="element.targetUserAuthorizations[header]" disabled></rs-checkbox>
          </td>
        </ng-container>
      }
      @if (header === 'documentsInd') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1" style="text-align: center;">
            <div style="padding: 10px 25px;">Documents</div>
          </th>
          <td rs-cell *rsCellDef="let element" class="col-1" style="text-align: center;">
            <rs-checkbox [checked]="element.targetUserAuthorizations[header]" disabled></rs-checkbox>
          </td>
        </ng-container>
      }
      <!-- this below code to add empty spaces for overall look -->
      @if (header === 'empty') {
        <ng-container rsColumnDef="{{header}}">
          <th rs-header-cell *rsHeaderCellDef class="col-1" style="text-align: center;">
            <div style="padding: 10px 25px;"></div>
          </th>
          <td rs-cell *rsCellDef="let element" class="col-1" style="text-align: center;">
          </td>
        </ng-container>
      }
    }
    <tr rs-header-row *rsHeaderRowDef="tableHeaders"></tr>
    <tr rs-row *rsRowDef="let row; columns: tableHeaders"></tr>
    <tr class="rs-row" *rsNoDataRow>
      <td colspan="12" style="text-align: center; height: 150px" class="rs-cell">
        <p>No Records Found</p>
        <p>Please try again!</p>
      </td>
    </tr>
  </table>
</div>

